var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.333h1.78a1.54 1.54 0 0 1 1.554 1.334v4.666a1.54 1.54 0 0 1-1.554 1.334h-1.78M6.667 10v2.667a2 2 0 0 0 2 2l2.666-6V1.333h-7.52A1.333 1.333 0 0 0 2.48 2.467l-.92 6A1.333 1.333 0 0 0 2.893 10h3.774Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDislike;